module.exports = __webpack_public_path__ + "static/media/place_students_generate_in_progress.8290dc3c.mov";